import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import { IBetData } from "../../../core/src/server/data/IBetData";
import App from "../../../core/src/App";
import { BetConfigType } from "../../../core/src/utils/ConfigType";
import BetModel from "../../../core/src/model/BetModel";
import Configs from "../../vendorConfigs/Configs";
import IPaytableMapItem from "../../../core/src/managers/contracts/configurations/IPaytableMapItem";
import CurrencyUtils from "../../../core/src/utils/CurrencyUtils";
export default class BetDataParser implements IBaseDataParser<IBetData> {
    check(data: any): boolean {
        return data?.data?.gameData?.lineLayout;
    }

    parse(data): IBetData[] {
        // Parsing the paytable map
        let paytableMap: IPaytableMapItem[] = [];
        Object.keys(data.data.gameData.payTable).forEach((id) => {
            const item = data.data.gameData.payTable[id];
            Object.keys(item).forEach((objectKey) => {
                let letters: string[] = [];
                if (App.config.paytableSymbolsMap) {
                    letters = App.config.paytableSymbolsMap[id];
                } else {
                    // 65 is capital A, 66 is capital B, etc..
                    letters = [String.fromCharCode(parseInt(id) + 65)];
                }

                letters.forEach(letter => {
                    const symbolsCount = parseInt(objectKey);
                    const multiplier = parseInt(item[objectKey]);
                    const key = `pt_sym_${letter}_${symbolsCount}`;
                    const paytableMapItem: IPaytableMapItem = {
                        key: key,
                        multiplier: multiplier
                    };

                    paytableMap.push(paytableMapItem);
                });
            });
        });

        Configs.settings.ptMap = paytableMap;

        // let bets = this.calculateMultipliers(data.Response.Bet.attributes);
        // TODO
        // let minChips = parseInt(data.Response.Bet.attributes.minChips);
        // let maxChips = parseInt(data.Response.Bet.attributes.maxChips);
        BetModel.betDivisor = data.data.gameData.betDivisor;
        BetModel.currencyRate = data.data.gameData.currencyRate || 1;
        BetModel.currencyMultiplier = data.data.gameData.currencyMultiplier = 1;

        const currencyISO = data.data.gameData.currency || "EUR"
        const decimals = data.data.gameData.currencyDecimalPlaces || 2;
        const symbol = data.data.gameData.currencySymbol || "€";
        const multi = BetModel.currencyRate;
        const locale = data.locale || data.country; // TODO: backend does not send such property yet.

        const currencyLocalization = CurrencyUtils.createCurrencyLocalization(
            currencyISO,
            symbol,
            decimals,
            multi,
            locale);

        BetModel.setCurrency(currencyLocalization);
        
        let bets:number[] = data.data.gameData.betPerLine;
        bets = bets.map( bet=> bet*data.data.gameData.betDivisor);
        let lines = data.data.gameData.lineLayout;
        let coinSize = data.data.gameData.betPerLineDefault*data.data.gameData.betDivisor;
        let result: IBetData = {
            betMultipliers: [1],
            // creditValues:  Utils.parseStringifiedListOfNumbers(data.Response.Bet.attributes.validChips),
            // betMultipliers: Utils.parseStringifiedListOfNumbers(
            //     data.Response.Bet.attributes.validChips
            // ),
            currentBetMultiplier:  1,
            creditValues: bets,
            coinSize,
            coinSizeIndex:bets.indexOf(coinSize),
            minLinesAllowed: 1,
            maxLinesAllowed: 1,
            currency:{
                decimals: currencyLocalization.currency.decimals,
                symbol: currencyLocalization.currency.symbol,
                ISO: currencyLocalization.currency.ISO
            },
            allPossibleBets: this.parsePossibleBets(
                bets,
                1
            ),
            numLines: 1,
        };

        return [result];
    }

    calculateMultipliers(data): number[] {
        let result = [];

        let min = parseFloat(data.minChips);
        let max = parseFloat(data.maxChips);

        for (let chipId = min; chipId <= max; chipId++) {
            result.push(chipId);
        }

        return result;
    }

    parsePossibleBets(
        bets,
        linesCount
    ): { coinIndex: number; multiplier: number; value: number }[] {
        let result = [];
        // let values = [];
        let betConfig = App.assets.getConfig("betConfig") as BetConfigType;
        // let validValues = betConfig.validBets;
        // let multipliers = Utils.parseStringifiedListOfNumbers(data.validChips);
        bets.forEach((bet,betIndex) => {
            // multipliers.forEach((val, coinIndex) => {
                let currentValue = bet * linesCount;
                // if (values.indexOf(currentValue) == -1 &&
                //     (!validValues || validValues.indexOf(currentValue) != -1)
                // ) {
                    // values.push(currentValue);
                    result.push({
                        total:currentValue,
                        coinIndex: betIndex,
                        multiplier: 1,
                        value:currentValue,
                    });
                // }
            // });
        });

        result = result.sort((a, b) => {
            if (a.total > b.total) {
                return 1;
            } else if (a.total < b.total) {
                return -1;
            }
            return 0;
        })

        return result;
    }
}
